import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./admin_blog.css";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { toast } from "react-toastify";

const addBlogEndpoint = ApiEndpoints.adminBlogs.blogCreate;
const authorListEndpoint = ApiEndpoints.autor.authorList;
const categoryListEndpoint = ApiEndpoints.category.categoryList;
const tagListEndpoint = ApiEndpoints.tags.tagList;

export default function AddBlogAdmin() {
  const navigate = useNavigate();

  // State variables
  const [categories, setCategories] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [tags, setTags] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    category_id: "",
    author_id: "",
    tag1: "",
    tag2: "",
    tag3: "",
    description: "",

    image: null,
    alt_image: "",
    section_image: null,
    alt_section_image: ""
  });

  const [previews, setPreviews] = useState({
    image: null,
    section_image: null
  });

  // Fetch data on mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await ApiRequest("GET", categoryListEndpoint);
        setCategories(response?.blog_categories || []);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        setCategories([]);
      }
    };

    const fetchAuthors = async () => {
      try {
        const response = await ApiRequest("GET", authorListEndpoint);
        setAuthors(response?.authors || []);
      } catch (error) {
        console.error("Failed to fetch authors:", error);
        setAuthors([]);
      }
    };

    const fetchTags = async () => {
      try {
        const response = await ApiRequest("GET", tagListEndpoint);
        setTags(response?.tags || []);
      } catch (error) {
        console.error("Failed to fetch tags:", error);
        setTags([]);
      }
    };

    fetchCategories();
    fetchAuthors();
    fetchTags();
  }, []);

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;

    if (type === "file") {
      const file = files[0];
      if (!file) return;

      // set file in form data
      setFormData(prev => ({ ...prev, [name]: file }));

      // set preview separately
      const previewUrl = URL.createObjectURL(file);
      setPreviews(prev => ({ ...prev, [name]: previewUrl }));
    } else {
      // normal text/select/textarea change
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleDescriptionChange = (event, editor) => {
    const data = editor.getData();
    setFormData(prev => ({ ...prev, description: data }));
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "name",
      "slug",
      "category_id",
      "author_id",
      "tag1",
      "tag2",
      "tag3",
      "description",
      "image",
      "alt_image",
      "section_image",
      "alt_section_image"
    ];

    const emptyField = requiredFields.find(field => {
      const value = formData[field];
      return value === "" || value === null;
    });

    if (emptyField) {
      toast.error(`Please fill out the ${emptyField.replace(/_/g, " ")} field`);
      return;
    }


    const fd = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== null && value !== "") fd.append(key, value);
    });


    try {
      const response = await ApiRequest("POST", addBlogEndpoint, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.error === true) {
        toast.error(response.message)
      } else {
        toast.success(response.message)
        navigate("/admin/blog");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <div className="header-add-category">
        <h5>Add Blogs</h5>
      </div>
      <div className="add-blog-content">
        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* Title Input */}
            <div className="col-md-12">
              <label>Title:</label>
              <input required type="text" name="name" onChange={handleChange} className="form-control" />
            </div>
            {/* slug Input */}
            <div className="col-md-12">
              <label>Slug:</label>
              <input required type="text" name="slug" onChange={handleChange} className="form-control" />
            </div>

            {/* Category Select */}
            <div className="col-md-12">
              <div className="form-group">
                <label>Blog Category</label>
                <select required className="form-control" name="category_id" value={formData.category_id || ""} onChange={handleChange}>
                  <option disabled value="">
                    Select Category
                  </option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Author Select */}
            <div className="col-md-12">
              <div className="form-group">
                <label >Author</label>
                <select required className="form-control" name="author_id" value={formData.author_id || ""} onChange={handleChange} >
                  <option disabled value="">
                    Select Author
                  </option>
                  {authors.map((auth) => (
                    <option key={auth._id} value={auth._id}>
                      {auth.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Tags Select */}
            <div className="col-md-4">
              <div className="form-group">
                <label>Tag 1</label>
                <select required className="form-control" name="tag1" value={formData.tag1 || ""} onChange={handleChange} >
                  <option disabled value="">
                    Select Tag
                  </option>
                  {tags.map((tag) => (
                    <option key={tag._id} value={tag._id}>
                      {tag.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Tag 2</label>
                <select required className="form-control" name="tag2" value={formData.tag2 || ""} onChange={handleChange}>
                  <option disabled value="">
                    Select Tag
                  </option>
                  {tags.map((tag) => (
                    <option key={tag._id} value={tag._id}>
                      {tag.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Tag 3</label>
                <select required className="form-control" name="tag3" value={formData.tag3 || ""} onChange={handleChange} >
                  <option disabled value="">
                    Select Tag
                  </option>
                  {tags.map((tag) => (
                    <option key={tag._id} value={tag._id}>
                      {tag.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Description Editor */}
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="des1">Description</label>
                <CKEditor required onChange={handleDescriptionChange} id="des1" editor={ClassicEditor} data={formData.description} config={{ toolbar: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote", "|", "undo", "redo",], }} />
              </div>
            </div>

            {/* Image Upload */}
            <div className="col-md-12">
              <div className="form-group">
                <label>Image(558 × 375 px)</label>
                <input required type="file" className="form-control" name="image" onChange={handleChange} />

                {previews.image && (
                  <img src={previews.image} alt="Preview" style={{ width: "100px", maxHeight: "300px" }} />
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label>Image Alt*</label>
                <input required type="text" className="form-control" name="alt_image" onChange={handleChange} />
              </div>
            </div>

            {/* Banner Image Upload */}
            <div className="col-md-12">
              <div className="form-group">
                <label>Banner Image(1116 x 416 px)</label>
                <input required type="file" className="form-control" name="section_image" onChange={handleChange} />

                {previews.section_image && (
                  <img src={previews.section_image} alt="Preview" style={{ width: "100px", maxHeight: "300px" }} />
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="bannerImage">Banner Image Alt*</label>
                <input required type="text" className="form-control" name="alt_section_image" onChange={handleChange} />
              </div>
            </div>

            {/* Submit Button */}
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary submit-formbtn">
                Add Blog
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
